import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  root: ({ shouldBeClickable }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    cursor: shouldBeClickable ? 'pointer' : 'default',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  }),
  leftSide: {
    padding: 0,
    marginBottom: theme.spacing(1),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
    },
  },
  captionText: {
    fontSize: '14px',
    color: 'rgba (0, 0, 0, .54)',
  },
  iconStyled: {
    backgroundColor: 'rgba(0, 35, 75, 0.08)',
    height: '48px',
    width: '48px',
    '& svg': {
      fontSize: '2rem',
    },
    [theme.breakpoints.down('sm')]: {
      height: '36px',
      width: '36px',
      '& svg': {
        fontSize: '1.5rem',
      },
    },
  },
  lessonInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  actionBar: {
    padding: 0,
    marginLeft: theme.spacing(1),
  },
  bookButton: {
    paddingLeft: 0,
    justifyContent: 'flex-start',
  },
  contentRoot: {
    padding: '8px 24px 24px 24px',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(5),
  },
  contentRootV2: {
    padding: '8px 24px 24px 24px',
    marginBottom: theme.spacing(3),
  },
  detailsRow: {
    margin: '20px 0',
  },
  rowIcon: {
    marginRight: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  rowIconPrimary: {
    marginRight: theme.spacing(4),
    color: theme.palette.primary,
    [theme.breakpoints.down('xs')]: {
      marginRight: theme.spacing(1),
    },
  },
  actionButtonContainer: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    display: 'flex',
  },
  dialogTitle: {
    background: theme.palette.primary.selected,
    height: '135px',
  },
  categoryIcon: {
    position: 'absolute',
    top: '110px',
    height: '80px',
    width: '80px',
    background: theme.palette.primary.light,
    '& svg': {
      width: '2.5rem !important',
      height: '2.5rem !important',
      '& path': {
        fill: '#FFF !important',
      },
    },
  },
  chip: {
    color: '#fff',
    borderRadius: '4px',
    height: '22px',
    fontSize: '10px',
  },
  chipInfo: {
    background: '#0B79D0',
    '&:not(:first-child)': {
      marginLeft: '6px',
    },
  },
  chipAttention: {
    color: '#E31B0C',
    borderColor: '#E31B0C',
    borderStyle: 'solid',
    background: 'none',
  },
  chipSuccess: {
    background: '#3B873E',
  },
  chipPrivate: {
    background: theme.palette.secondary.main,
  },
  chipWarning: {
    background: '#C77700',
    marginRight: theme.spacing(1),
  },
  alignRight: {
    marginLeft: 'auto',
    float: 'right',
  },
  cardBottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
      marginTop: theme.spacing(1),
    },
  },
}))
